import React, { useState, useRef, useEffect } from 'react';
import { useSocket } from '../context/SocketContext';
import { useAuth } from '../context/AuthContext';
import { useSound } from '../hooks/useSound';
import useViewport from '../hooks/useViewport';

function escapeText(str) {
  return String(str || '').replace(/[<>&"']/g, c =>
    ({ '<':'&lt;', '>':'&gt;', '&':'&amp;', '"':'&quot;', "'":'&#39;' }[c])
  );
}

export default function Chat() {
  const [open,  setOpen]  = useState(false);
  const [input, setInput] = useState('');
  const { chatMessages, sendChat } = useSocket();
  const { user } = useAuth();
  const { playClick, playHover } = useSound();
  const { isMobile } = useViewport();
  const endRef = useRef(null);

  useEffect(() => {
    if (open) endRef.current?.scrollIntoView({ behavior:'smooth' });
  }, [chatMessages, open]);

  const handle = () => {
    const t = input.trim();
    if (!t || !user) return;
    playClick();
    sendChat(t);
    setInput('');
  };

  const toggle = () => { playClick(); setOpen(o => !o); };

  return (
    <div style={{
      position:'fixed', bottom:0, right:0, width:isMobile ? '100%' : '290px', maxWidth:'100vw', zIndex:200,
      background:'rgba(8,8,14,0.97)',
      borderTop:'1px solid rgba(0,245,255,0.17)', borderLeft:'1px solid rgba(0,245,255,0.12)',
      transform: open ? 'translateY(0)' : 'translateY(calc(100% - 42px))',
      transition:'transform 0.3s cubic-bezier(0.16,1,0.3,1)',
      display:'flex', flexDirection:'column',
      backdropFilter:'blur(14px)', WebkitBackdropFilter:'blur(14px)',
      boxShadow:'0 0 30px rgba(0,245,255,0.08), -2px 0 20px rgba(0,0,0,0.5)',
    }}>
      <div onClick={toggle} style={{
        padding:isMobile ? '10px 12px' : '10px 14px', cursor:'pointer', userSelect:'none',
        display:'flex', alignItems:'center', justifyContent:'space-between',
        borderBottom: open ? '1px solid rgba(0,245,255,0.1)' : 'none',
        flexShrink:0,
        background: open ? 'rgba(0,245,255,0.04)' : 'transparent',
        transition:'background 0.2s',
      }}
        onMouseEnter={() => playHover()}
      >
        <span style={{ fontFamily:'var(--font-game)', fontSize:isMobile ? '12px' : '15px', fontWeight:700, color:'#00f5ff', letterSpacing:isMobile ? '1px' : '2px', textShadow:'0 0 8px rgba(0,245,255,0.4)' }}>
          ⚡ GLOBAL CHAT
          {!open && chatMessages.length > 0 &&
            <span style={{ marginLeft:'8px', background:'#00f5ff', color:'#000', borderRadius:'10px', padding:'1px 6px', fontSize:'15px', fontWeight:700 }}>
              {chatMessages.length}
            </span>}
        </span>
        <span style={{ color:'rgba(255,255,255,0.4)', fontSize:'15px' }}>{open ? '▼' : '▲'}</span>
      </div>

      {open && (
        <>
          <div style={{ height:isMobile ? '150px' : '180px', overflowY:'auto', padding:'8px 12px', display:'flex', flexDirection:'column', gap:'5px' }}>
            {chatMessages.map((m, i) => (
              <div key={i} style={{ fontSize:'15px', color:'rgba(255,255,255,0.6)', lineHeight:1.5 }}>
                <span style={{ color: m.username === user?.username ? '#00f5ff' : 'rgba(0,245,255,0.65)', fontWeight:700, marginRight:'6px' }}>
                  {m.avatar || '🧑‍💻'} {m.username}
                </span>
                {escapeText(m.text)}
              </div>
            ))}
            <div ref={endRef} />
          </div>
          <div style={{ display:'flex', padding:'7px 10px', gap:'6px', borderTop:'1px solid rgba(0,245,255,0.1)', flexShrink:0 }}>
            <input
              value={input} onChange={e => setInput(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handle()}
              placeholder="Say something..." maxLength={300}
              style={{ flex:1, background:'rgba(0,245,255,0.04)', border:'1px solid rgba(0,245,255,0.15)', borderRadius:'4px', padding:'6px 8px', color:'#e2e8f0', fontSize:'15px', outline:'none', fontFamily:'var(--font-ui)', transition:'border-color 0.2s' }}
              onFocus={e => e.target.style.borderColor='rgba(0,245,255,0.4)'}
              onBlur={e => e.target.style.borderColor='rgba(0,245,255,0.15)'}
            />
            <button onClick={handle} style={{ padding:'6px 10px', background:'rgba(0,245,255,0.1)', border:'1px solid rgba(0,245,255,0.28)', borderRadius:'4px', color:'#00f5ff', cursor:'pointer', fontSize:'15px', fontWeight:700, transition:'all 0.2s' }}
              onMouseEnter={e => { playHover(); e.currentTarget.style.background='rgba(0,245,255,0.2)'; }}
              onMouseLeave={e => { e.currentTarget.style.background='rgba(0,245,255,0.1)'; }}
            >SEND</button>
          </div>
        </>
      )}
    </div>
  );
}
